module.exports = function ($el, triggerType) {
    var name = $el.data('popupModalName');

    dataLayer.push({
        event: 'popupOpen',
        triggerType: triggerType,
        name: name
    });
};